import { CheckFilledIcon, CopyIcon } from 'cokitchen-icons';
import React, { FC, useState } from 'react';
import { copyTextToClipboard } from 'utils/functions';

type Props = {
  text: string;
  className?: string;
};

const CopyText: FC<Props> = ({ text, className = '' }) => {
  const [hasCopied, setHasCopied] = useState(false);

  const handleCopy = () => {
    copyTextToClipboard(text);
    setHasCopied(true);
    setTimeout(() => {
      setHasCopied(false);
    }, 3000);
  };

  return (
    <div
      role='note'
      className={`inline-flex items-center gap-2 cursor-pointer ${className}`}
      onClick={handleCopy}>
      <span>{text}</span>
      {hasCopied ? (
        <CheckFilledIcon className='text-green-5' />
      ) : (
        <CopyIcon className='text-blue-5' />
      )}
    </div>
  );
};

export default CopyText;
